/**
 * Boas-vindas (docs/design/pranchas/07): "Começar grátis" e "Já tenho conta" levam ao mesmo e-mail
 * (um caminho só, sem senha). No computador a própria tela já é o formulário de entrar.
 */
import { useNavigate } from 'react-router-dom';
import agenda from './assets/agenda.webp';
import { Brand, useDesktop } from './EntrarShell';
import { Login } from './Login';
import './entrar.css';

export function Welcome() {
  const navigate = useNavigate();
  const desktop = useDesktop();
  if (desktop) return <Login />;
  return (
    <main className="en-page en-wel">
      <Brand />
      <div className="en-wel-body">
        <h1 className="en-wel-t">
          <span>Abra sua agenda.</span> <span>Sua cliente marca sozinha.</span>
        </h1>
        <p className="en-wel-p">Marque em 2 toques, lembre a cliente pelo WhatsApp e saiba quanto entrou no mês.</p>
        <figure className="en-shot">
          <img
            src={agenda}
            alt="A agenda no celular: uma cliente pediu horário, a próxima vem às 10h30 e sobram 2 horas livres ao meio-dia"
            width={390}
            height={213}
          />
        </figure>
      </div>
      <div className="en-foot">
        <p className="en-trial">14 dias grátis, sem cartão.</p>
        <button className="btn btn--primary en-cta" onClick={() => navigate('/cadastro')}>
          Começar grátis
        </button>
        <button className="btn btn--outline en-cta2" onClick={() => navigate('/entrar')}>
          Já tenho conta
        </button>
      </div>
    </main>
  );
}
